import { useState, useEffect } from 'react'
import { ExternalLink, Sparkles, RefreshCw, Info } from 'lucide-react'

export function JumpBookingWidget() {
  const [isLoading, setIsLoading] = useState(true)

  const iframeUrl =
    'https://www.conventus.dk/dataudv/www/booking_v2_liste_link.php?forening=973&vis=30&ressourcer=45176&kategorier=&kun_egne=false&skyggebookinger=true&type=2&gruppeAfd=&columns=skygge;dato;tid;titel;antal_pl;book&heads=day'

  useEffect(() => {
    // Automatically turn off loading spinner after 3 seconds as a fallback
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="my-12 rounded-[2rem] border border-slate-200 bg-slate-50/50 p-6 shadow-sm sm:p-8">
      {/* Header */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b border-slate-200 pb-6 mb-6">
        <div>
          <h3 className="text-xl font-extrabold text-slate-950 flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-[#3B70E5]" />
            Program &amp; Booking – Jump Fitness
          </h3>
          <p className="mt-1 text-sm text-slate-600">
            Herunder kan du se de aktuelle træningstider 30 dage frem og booke en trampolin direkte via Conventus. Det koster 35 kr. pr. gang.
          </p>
        </div>

        {/* Open in New Tab Button */}
        <a
          href={iframeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#3B70E5] px-4 py-2 text-xs font-semibold text-white transition hover:bg-[#3B70E5]/90 shadow-sm shrink-0"
        >
          <span>Åbn i nyt vindue</span>
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>

      {/* Subtle Loading Status */}
      {isLoading && (
        <div className="mb-4 flex items-center gap-2 text-xs font-semibold text-slate-500 bg-white border border-slate-200 rounded-full px-4 py-2 w-fit animate-pulse">
          <RefreshCw className="h-3.5 w-3.5 text-[#3B70E5] animate-spin" />
          <span>Henter det aktuelle program fra Conventus...</span>
        </div>
      )}

      {/* Booking Widget Container */}
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm w-full">
        <iframe
          frameBorder="0"
          src={iframeUrl}
          title="Conventus Jump Fitness Booking"
          className="w-full min-w-full min-h-[650px] sm:min-h-[750px] md:min-h-[850px] border-0 block"
          onLoad={() => setIsLoading(false)}
          allow="payment"
        />
      </div>

      {/* Info Footer */}
      <div className="mt-4 flex items-start gap-2.5 text-xs text-slate-500 px-2">
        <Info className="h-4 w-4 text-slate-400 shrink-0 mt-0.5" />
        <p>
          Bookingsystemet leveres og opdateres i realtid af Conventus. Hvis du oplever problemer med visningen eller din tilmelding, kan du med fordel klikke på "Åbn i nyt vindue" øverst til højre.
        </p>
      </div>
    </div>
  )
}
